var map = {
	"./Facebook.svg": 297,
	"./Insta.svg": 296,
	"./Linkedin.svg": 300,
	"./Twitter.svg": 298,
	"./Youtube.svg": 299,
	"./bncimagenes.png": 512,
	"./bonificaciones.png": 513,
	"./calendar.svg": 304,
	"./clientes.svg": 514,
	"./download.svg": 515,
	"./editar.svg": 305,
	"./editar_black.svg": 306,
	"./excel-logo.png": 307,
	"./manualmarca.png": 516,
	"./menu.svg": 303,
	"./precios.png": 517,
	"./presupuesto.svg": 518,
	"./vendedores.svg": 519
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 511;